var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgIconIonicIosGift = function SvgIconIonicIosGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-ionic-ios-gift_svg__Icon_ionic-ios-gift",
    "data-name": "Icon ionic-ios-gift",
    viewBox: "0 0 9.974 10.741"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-ionic-ios-gift_svg__cls-1{fill:#fff}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-ionic-ios-gift_svg__Path_2169",
    "data-name": "Path 2169",
    className: "icon-ionic-ios-gift_svg__cls-1",
    d: "M12.581 4.743H10.56a1.409 1.409 0 00.487-1.055A1.478 1.478 0 009.534 2.25a1.338 1.338 0 00-1.172.657 1.338 1.338 0 00-1.173-.657 1.478 1.478 0 00-1.512 1.438 1.4 1.4 0 00.487 1.055H4.142a.766.766 0 00-.767.767v.48a.1.1 0 00.1.1h9.782a.1.1 0 00.1-.1v-.479a.766.766 0 00-.776-.768zM9.534 2.921a.788.788 0 01.808.767.788.788 0 01-.808.767h-.808c0-1.155.362-1.534.808-1.534zm-2.345 0c.446 0 .811.379.811 1.535h-.811a.788.788 0 01-.808-.767.788.788 0 01.808-.768z",
    transform: "translate(-3.375 -2.25)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "icon-ionic-ios-gift_svg__Path_2170",
    "data-name": "Path 2170",
    className: "icon-ionic-ios-gift_svg__cls-1",
    d: "M4.5 15.52v5.322a.769.769 0 00.767.767h3.5v-6.281H4.692a.192.192 0 00-.192.192z",
    transform: "translate(-4.116 -10.869)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "icon-ionic-ios-gift_svg__Path_2171",
    "data-name": "Path 2171",
    className: "icon-ionic-ios-gift_svg__cls-1",
    d: "M23.06 15.328h-4.076v6.282h3.5a.769.769 0 00.767-.767V15.52a.192.192 0 00-.191-.192z",
    transform: "translate(-13.662 -10.869)"
  })));
};
export default SvgIconIonicIosGift;